import { render, staticRenderFns } from "./shopping-basket.vue?vue&type=template&id=0767d0d4"
import script from "./shopping-basket.vue?vue&type=script&lang=ts"
export * from "./shopping-basket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports